import { render, staticRenderFns } from "./UploadEmceeDraft.vue?vue&type=template&id=22f55777"
import script from "./UploadEmceeDraft.vue?vue&type=script&lang=js"
export * from "./UploadEmceeDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports